module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Bold-f7508d2aa9697010a7c42faeba33da4c.woff";